module.exports = __webpack_public_path__ + "static/media/hug-circle.ea311b31.jpg";